import {action, extendObservable, observable} from 'mobx';
import { create, round } from 'lodash/fp';

// logic dependencies
import CONSTANTS from 'logic/data/Izenda.ReportDesignerFormatsConstants';

// shart dependencies
import GridLayoutUIStore from 'share/components/controls/GridLayout/Izenda.GridLayoutUIStore';

/**
 * @class KPIGridLayoutUIStore
 * @extends GridLayoutUIStore
 * @description describe and control the KPI grid
 * @property {Boolean} transparent indicator for if the background of the grid is transparent
 */
export default class KPIGridLayoutUIStore extends GridLayoutUIStore {
    @observable activeGridItem = null;
    @observable transparent = false;
    @observable rows;

    // used to disable setting cell sizing based on 
    isKPILayout = true;

    constructor({numRows, numCols, cellSize}) {
        const {
            GRID_ROWS_COLUMNS,
            ROW_HEIGHT,
        } = CONSTANTS;
        const width = cellSize && numCols ? cellSize * numCols : ROW_HEIGHT * GRID_ROWS_COLUMNS;
        super(
            cellSize || ROW_HEIGHT, // Initial square cell dim
            cellSize || ROW_HEIGHT, // Initial square cell dim
            width, // grid width
            numCols || GRID_ROWS_COLUMNS, // number of grid rows
            numRows || GRID_ROWS_COLUMNS, // number of grid cols
            false, // infinityRows
            false, // infinityCol
            false, // isFullSize
            false // allowSwap
        );
    }

    /**
     * @method setTransparent
     * @description set the transparent property
     * @param {Boolean} isTransparent indicator for if the background of the grid should be transparent
     */
    @action
    setTransparent(isTransparent) {
        this.transparent = isTransparent;
    }

    @action
    setActiveGridItem(offset) {
        this.activeGridItem = offset;
    }

    /**
     * @method updateGridDimensions
     * @description update number of row, columns, and cell size as well as width
     * @param {number} numRows number of rows in grid
     * @param {number} numCols new number of columns in the grid
     * @param {number} cellSize new pixels width and height of each grid cell
     */
    @action
    updateGridDimensions({numRows, numCols, cellSize}) {
        this.rows = numRows || this.rows;
        this.cols = numCols || this.cols;
        this.cellWidth = cellSize || this.cellWidth;
        this.cellHeight = cellSize || this.cellHeight;
        this.setViewWidth(this.cellWidth * this.cols);
        this.recalculateLayoutPosition();
        this.resetOverlayPosition();
    }
}



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartKPI/Izenda.KPIGridLayoutUIStore.js